import { Skeleton } from '@mui/material';
import PropTypes from 'prop-types';

const InputSkeleton = ({ height = 48, sx = {} }) => {
  return <Skeleton variant='rounded' height={height} sx={{ borderRadius: 2, ...sx }} />;
};

InputSkeleton.propTypes = {
  height: PropTypes.number,
  sx: PropTypes.object,
};

export default InputSkeleton;
